/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type SuggestionBodyLowFocusTime_suggestionPayload = {
    readonly calendarId: string | null;
    readonly totalFocusTimeMinutes: number | null;
    readonly totalMinutes: number | null;
    readonly week: string | null;
    readonly " $refType": "SuggestionBodyLowFocusTime_suggestionPayload";
};
export type SuggestionBodyLowFocusTime_suggestionPayload$data = SuggestionBodyLowFocusTime_suggestionPayload;
export type SuggestionBodyLowFocusTime_suggestionPayload$key = {
    readonly " $data"?: SuggestionBodyLowFocusTime_suggestionPayload$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"SuggestionBodyLowFocusTime_suggestionPayload">;
};



const node: ReaderFragment = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "SuggestionBodyLowFocusTime_suggestionPayload",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "calendarId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalFocusTimeMinutes",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "totalMinutes",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "week",
            "storageKey": null
        }
    ],
    "type": "SuggestionResultLowFocusTimePayload",
    "abstractKey": null
} as any;
(node as any).hash = 'd9624513b187b43aae9357ec82ca5392';
export default node;
